export default class SecondaryFiltersViewModel {
    useClasses: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27];
    populationOneMile: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    populationFiveMile: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    Population500MeterChecked: boolean = true;
    population500MeterMin: number = -1;
    population500MeterMax: number = -1;
    carOwnership: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    ptalRating: (string | null)[] = ["0", "1a", "1b", "2", "3", "4", "5", "6a", "6b", "-1"];
    travelPlan: number[] = [1, 2, 3];
    publicTransportProvision: number = 1;
    publicTransportMin: number = 0;
    publicTransportMax: number = 0;
    petrolFillingStation: string[] = ["0", "1", "2"];

    siteOperationsChecked: boolean = true;
    siteOperation: number = 0;
    siteOperationIsMin: boolean = true;
    siteOperationPercentage: number = 100;
}